import React, {Component} from 'react'

import style from './about.sass'

class About extends Component {
  render() {
    return(
      <section id='about'>
        <div className='landing-container' styleName='container'>
          <div styleName='main'>
            <h4>About Us</h4>
            <p>
              Algoriz is headquartered in New York City and is built by alumni of Goldman Sachs and Millennium partners Hedge fund.
              The team has deep domain expertise in quantitative trading, machine learning, and capital markets with a successful
              track record of building technology within the financial services sector.
            </p>
          </div>
          <div styleName='side'>
            <ul>
              <li>
                <h5 styleName='address'>Address</h5>
                <address>110 Third Ave, New York, NY, 10003</address>
              </li>
              <li>
                <h5 styleName='email'>Email</h5>
                <a href='mailto:info@algoriz.com'>info@algoriz.com</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    )
  }
}

export default About
